import React, { useEffect } from 'react';
import { t } from '../useTranslations';
import '../styles/UnsavedChangesWarning.css';

const UnsavedChangesWarning = ({ isOpen, onStay, onLeave }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onStay();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onStay]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content warning-modal">
        <h3>{t('common.unsavedChangesTitle')}</h3>
        <p>{t('common.unsavedChangesMessage')}</p>
        <div className="warning-buttons">
          <button onClick={onStay}>{t('common.stay')}</button>
          <button onClick={onLeave} className="warning-button">{t('common.leave')}</button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesWarning;
